// extracted by mini-css-extract-plugin
export default {"Alert":"Alert_Alert__SOJi2","Alert-wrapper":"Alert_Alert-wrapper__2SSi5"};